'use strict';

import Api from "./Api";

export default class Report extends Api {

    static getNoVisitClients(noVisitDays = 21, activity = 1, subscriptionIds = []) {
        const url = this.url + 'report/get-no-visit-client';

        return this.getAxios().get(url, {
            params: {
                noVisitDays: noVisitDays,
                activity: activity,
                subscriptions: subscriptionIds,
            },
        });
    }

    static getWithVisitClients(noVisitDays = 60, activity = 1, subscriptionIds = []) {
        const url = this.url + 'report/get-with-visit-client';

        return this.getAxios().get(url, {
            params: {
                noVisitDays: noVisitDays,
                activity: activity,
                subscriptions: subscriptionIds,
            },
        });
    }

    static getSalary(from, to, trainerId = undefined) {
        const url = this.url + 'report/get-salary';

        return this.getAxios().get(url, {
            params: {
                from: from,
                to: to,
                trainerId: trainerId,
            },
        });
    }

    static getTrainerEfficiency(from, to) {
        const url = this.url + 'report/get-trainer-efficiency';

        return this.getAxios().get(url, {
            params: {
                from: from,
                to: to,
            },
        });
    }

    static getGroupEfficiency(from, to) {
        const url = this.url + 'report/get-group-efficiency';

        return this.getAxios().get(url, {
            params: {
                from: from,
                to: to,
            },
        });
    }

    static getAdminEfficiency(from, to) {
        const url = this.url + 'report/get-admin-efficiency';

        return this.getAxios().get(url, {
            params: {
                from: from,
                to: to,
            },
        });
    }

    static getClientSource(from, to) {
        const url = this.url + 'report/get-client-source';

        return this.getAxios().get(url, {
            params: {
                from: from,
                to: to,
            },
        });
    }

    static getCashflowInfo(from, to) {
        const url = this.url + 'report/get-cashflow-info';

        return this.getAxios().get(url, {
            params: {
                from: from,
                to: to,
            },
        });
    }

    static getAverageDurationBetweenSale(from, to) {
        const url = this.url + 'report/get-average-duration-between-sale';

        return this.getAxios().get(url, {
            params: {
                from: from,
                to: to,
            },
        });
    }

    static getClientBySource(from, to, source = 0, getXlsx = false) {
        const url = this.url + 'report/get-client-by-source';

        return this.getAxios().get(url, {
            headers: getXlsx ? {accept: 'application/vnd.ms-excel'} : {},
            params: {from, to, source},
            responseType: getXlsx ? 'blob' : 'json',
        });
    }

    static getAverageDurationBetweenVisit(from, to) {
        const url = this.url + 'report/get-average-duration-between-visit';

        return this.getAxios().get(url, {
            params: {
                from: from,
                to: to,
            },
        });
    }

    static getSaleWeekInfo(from, to) {
        const url = this.url + 'report/get-sale-week-info';

        return this.getAxios().get(url, {
            params: {
                from: from,
                to: to,
            },
        });
    }
}
